module.exports = __webpack_public_path__ + "img/logo.0a181e2e.png";